'use client';

import AccountsPage from './components/AccountsPage';

export default function Page() {
  return <AccountsPage />;
}
